import * as ENV_LOCAL from './env-local.web.js';
import * as ENV_LOCAL_MIL from './env-local_mil.web.js';
import * as ENV_STAGING from './env-staging.web.js';
import * as ENV_STAGING_MIL from './env-staging_mil.web.js';
import * as ENV_PRODUCTION from './env-production.web.js';
import * as ENV_PREPROD from './env-preprod.web.js';

const selectedEnv =
  {
    development: ENV_LOCAL,
    dev_mil: ENV_LOCAL_MIL,
    staging: ENV_STAGING,
    'staging-azure': ENV_STAGING_MIL,
    production: ENV_PRODUCTION,
    preprod: ENV_PREPROD,
  }[OVERRIDE_ENV || window.OP_ENV] || ENV_LOCAL;

export function env(propName) {
  return selectedEnv[propName];
}

export const ENV_NAME = 'ENV_NAME';
export const DISABLE_ANALYTICS = 'DISABLE_ANALYTICS';
export const BASE_URL = 'BASE_URL';
export const BASE_WS_URL = 'BASE_WS_URL';
export const CLOUD_PROVIDER = 'CLOUD_PROVIDER';
export const S3_PUBLIC_BUCKET_URL = 'S3_PUBLIC_BUCKET_URL';
export const TURNSTYLE_SITE_KEY = 'TURNSTYLE_SITE_KEY';
export const USE_OKTA = 'USE_OKTA';
export const OKTA_CLIENT_ID = 'OKTA_CLIENT_ID';
